export default __webpack_public_path__ + "static/media/googlePlay.fa9c04e1.svg";